import SignRiskFormError from './SignRiskFormError';
class SessionWithoutLocationCanNotSignRiskForm extends SignRiskFormError {
    constructor(options) {
        super('Can not sign risk form because investor has not geolocation in the current session', options);
    }
}
export default SessionWithoutLocationCanNotSignRiskForm;
